import { useMutation } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";

export type UseCheckUserExistsParameters = {
    groupID: number
} & BaseUseMutationParameters<boolean, {userLogin: string}>;

export function useCheckUserExists({
    groupID,
    onError,
    onSuccess
}: UseCheckUserExistsParameters) {

    return useMutation<boolean, RestError, {userLogin: string}>(
        async (data) => {
            return await UserRoleAdministrationService.checkUserExists(groupID, data.userLogin);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}